import { IdentityProviderData } from './types';

export const FETCH_INSTITUTION_IDP_DATA_SUCCESS =
  'FETCH_INSTITUTION_IDP_DATA_SUCCESS';

export const SET_SAML_IDP_COHORT_ID = 'SET_SAML_IDP_COHORT_ID';

export type FetchInstitutionIdpData = {
  type: 'FETCH_INSTITUTION_IDP_DATA_SUCCESS';
  institutionPath: string;
  idps: IdentityProviderData[];
};

export type SetCohortId = {
  type: 'SET_SAML_IDP_COHORT_ID';
  cohortId: string;
};

export type IdentityProviderActions = FetchInstitutionIdpData | SetCohortId;
